<template>
    <v-card class="ma-3 pa-5">
        <h3>Create Calculation</h3>

        <v-simple-table dense>
            <template v-slot:default>
                <tbody>
                <tr>
                    <td class="index-textarea">
                        <v-textarea class="index" rows="1" placeholder="Index" auto-grow flat dense solo hide-details
                                    v-model="newCalculation.index"></v-textarea>
                    </td>

                    <td>
                        <v-textarea rows="1" placeholder="Formula" auto-grow flat dense solo hide-details
                                    v-model="newCalculation.formula"></v-textarea>
                    </td>

                    <td>
                        <v-select item-value="id"
                                  item-text="locale.en_culture"
                                  multiple
                                  hide-details
                                  dense
                                  :items="tData"
                                  label="Culture"
                                  v-model="newCalculation.culture">
                            <template v-slot:prepend-item>
                                <v-list-item
                                        ripple
                                        @mousedown.prevent
                                        @click="handleSelectAllClick"
                                >
                                    <v-list-item-action>
                                        <v-icon color="indigo darken-4">
                                            {{ toggleAllIcon }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Select All
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index < 2">
                                    <span>{{ item.locale.en_culture }}</span>
                                </v-chip>
                                <span
                                        v-if="index === 2"
                                        class="grey--text text-caption"
                                >
          (+{{ newCalculation.culture.length - 2 }} others)
        </span>
                            </template>
                        </v-select>
                    </td>

<!--                    <td class="sensor-width">-->
<!--                        <v-checkbox-->
<!--                                dense-->
<!--                                hide-details-->
<!--                                :ripple="false"-->
<!--                                v-model="newCalculation.sensor_high"-->
<!--                                label="High"-->
<!--                        ></v-checkbox>-->
<!--                        <v-checkbox-->
<!--                                dense-->
<!--                                hide-details-->
<!--                                :ripple="false"-->
<!--                                v-model="newCalculation.sensor_low"-->
<!--                                label="Low"-->
<!--                        ></v-checkbox>-->
<!--                    </td>-->

                    <td>
                        <v-select
                                item-value="id"
                                item-text="name"
                                hide-details
                                dense
                                multiple
                                :items="soils"
                                placeholder="Soil types"
                                v-model="newCalculation.soil_type">
                        </v-select>
                    </td>

                    <td>
                        <v-select
                                item-value="id"
                                item-text="code"
                                hide-details
                                dense
                                multiple
                                :items="countries"
                                placeholder="Countries"
                                v-model="newCalculation.countries">
                        </v-select>
                    </td>

                    <td>
                        <v-menu
                                class="date-to-menu"
                                v-model="show_date_from_menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                        class="date-to-menu"
                                        :value="formatDate(newCalculation.date_from)"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                    :show-current="false"
                                    first-day-of-week="1"
                                    v-model="newCalculation.date_from"
                                    @input="show_date_from_menu = false"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                                class="date-to-menu"
                                v-model="show_date_to_menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                        class="date-to-menu"
                                        :value="formatDate(newCalculation.date_to)"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                    :show-current="false"
                                    first-day-of-week="1"
                                    v-model="newCalculation.date_to"
                                    @input="show_date_to_menu = false"
                            ></v-date-picker>
                        </v-menu>
                    </td>

                    <td>
                        <v-select item-value="id" item-text="index" hide-details dense :items="rec_data"
                                  placeholder="Recommendation"
                                  v-model="newCalculation.recommendation"/>
                    </td>
                    <td style="display: flex; padding-top: 70px">
                        <v-icon
                                class="mr-2"
                                @click="handleNewCalculationClick()"
                        >
                            mdi-content-save-outline
                        </v-icon>

                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-card>
</template>

<script>
import {mapActions, mapMutations, mapState, mapGetters} from "vuex";
import moment from "moment";

export default {
    name: "CreateCalculationCard",
    data() {
        return {
            soils: [],
            tData: [],
            field_culture: [],
            rec_data: [],
            show_date_from_menu: false,
            show_date_to_menu: false,
        }
    },
    computed: {
        ...mapState('culture', ['cultures']),
        ...mapState('soil', ['soilTypes']),
        ...mapState('rec', ['tableData']),
        ...mapState('country', ['countries']),
        ...mapState('calculation', ['newCalculation', 'calculationData']),
        ...mapGetters('calculation', ['getNextCalculationIndex']),
        toggleAllIcon() {
            if (this.newCalculation.culture?.length === this.tData.length) return 'mdi-close-box'
            if (this.newCalculation.culture?.length > 0) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        }
    },
    async mounted() {
        await this.fetchCulture()
        await this.fetchSoilTypesList()
        await this.fetchCountries()
    },
    watch: {
        cultures: function () {
            this.tData = this.cultures
            for (let i = 0; i < this.cultures.length; i++) {
                this.field_culture.push(this.cultures[i].locale.en_culture)
            }
        },
        soilTypes: function () {
            for (let i = 0; i < this.soilTypes.length; i++) {
                this.soils.push(this.soilTypes[i])
            }
        },
        tableData: function () {
            for (let i = 0; i < this.tableData.length; i++) {
                this.rec_data.push(this.tableData[i])
            }
        },
        calculationData: function () {
            const newCalcIndex = this.getNextCalculationIndex
            this.setNewCalcIndex({index: newCalcIndex})
        }
    },
    methods: {
        ...mapActions('culture', ['fetchCulture']),
        ...mapActions('soil', ['fetchSoilTypesList']),
        ...mapActions('country', ['fetchCountries']),
        ...mapActions('calculation', ['handleNewCalculationClick']),
        ...mapMutations('calculation', ['setNewCalcCultures', 'setNewCalcIndex']),
        formatDate(date) {
            if (date) {
                return moment(date).format('DD.MM.YY')
            }
            return '-'
        },
        async handleSelectAllClick() {
            if (this.newCalculation.culture.length === this.tData.length) {
                await this.setNewCalcCultures([])
            } else {
                const allCultureIds = this.tData.map(c => c.id)
                await this.setNewCalcCultures(allCultureIds)
            }
        }
    },
}
</script>

<style scoped>
.date-to-menu {
    margin: 0;
    padding: 0;
}

.index-textarea {
    width: 8%;
}

.title-padding {
    padding-left: 27px !important;
}

.sensor-width {
    padding: 8px !important;
}
</style>